<template>
  <div>
    <el-select
      v-model="providerIds"
      :placeholder="isSelectedAllProviders ? 'เลือกผู้ให้บริการทั้งหมดแล้ว' : 'เลือกผู้ให้บริการ'"
      :disabled="isSelectedAllProviders"
      class="provider-selector"
      filterable
      clearable
      multiple
    >
      <el-option
        v-for="item in providerOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
        <div class="provider-option">
          <img :src="item.logoUrl" class="icon" />
          <div class="name">{{ item.name }}</div>
        </div>
      </el-option>
    </el-select>
    <el-checkbox
      v-model="isSelectedAllProviders"
      class="mt-2">
      เลือกทั้งหมด
    </el-checkbox>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      providers: [],
      providerIds: [],
      isSelectedAllProviders: false
    };
  },
  computed: {
    providerOptions() {
      return this.providers.map((provider) => ({
          ...provider,
          name: provider.nameOnSap
            ? `${provider.name} - ${provider.nameOnSap}`
            : provider.name
        }));
    }
  },
  watch: {
    providerIds(value) {
      this.$emit("providerIds", value);
    },
    isSelectedAllProviders(value) {
      if (value) this.providerIds = [];

      this.$emit("isSelectedAllProviders", value);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupDefaultValues();
      this.setupProviders();
    },
    setupDefaultValues() {
      const {
        manageProviderIds = [],
        canManageAllProviders = false
      } = this.value;

      this.providerIds = manageProviderIds;
      this.isSelectedAllProviders = canManageAllProviders;
    },
    async setupProviders() {
      const providers = await this.fetchProviders();

      this.providers = providers.map(provider => {
        const {
          id,
          name,
          icon_url: logoUrl = "https//placehold.it/64",
          name_on_sap: nameOnSap
        } = provider;

        return {
          id,
          name,
          logoUrl,
          nameOnSap
        };
      });
    },
    async fetchProviders() {
      const response = await baanRueJaiClient.admin.subscriptions.providers.list();

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.provider-selector {
  width: 100%;
}

.provider-selector:hover {
  width: 100%;
  display: block;
  font-size: 14px;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>
